export function isBlob(data: unknown): data is Blob {
  // File is instance of Blob, but file constructor has non-optional name property, so we can use it to distinguish between Blob and File
  return data instanceof Blob && typeof (data as File).name !== 'string';
}
